import Vue from 'vue';

Vue.component('register-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            selectedParentAccount: false,
            buttonDisabled: false,
            showDateOfBirthMessage: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        changeFormSelect(event) {
            const select = event.currentTarget;
            select.classList.remove('input-select--unselected');
            select.classList.add('input-select--selected');
        },
    },
});
